<p>param-duplication-module works!</p>
